/* eslint-disable */

<template>
  <div>
    <div class="vx-row">

      <div class="vx-col lg:w-4/12 md:w-5/12 sm:w-5/5 mb-4">
        <div class="flex gap-2 mb-2">
          <vs-button :color="sel==='r2'?'primary':'grey'" type="filled" class="flex-1" @click="sel='r2'">R2</vs-button>
          <vs-button :color="sel==='r3'?'primary':'grey'" type="filled" class="flex-1" @click="sel='r3'">R3</vs-button>
          <vs-button :color="sel==='sw1'?'primary':'grey'" type="filled" class="flex-1" @click="sel='sw1'">Sw1</vs-button>
        </div>

        <vx-card style="height: 42rem; overflow-y: auto">

          <!-- Task 1 -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{border:'1px solid '+(task1Done?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:task1Done?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{width:'20px',height:'20px',fontSize:'10px',background:task1Done?'#28C76F':'#4a5568'}">1</span>
              <span class="font-semibold text-sm flex-1">PAT on R2 — translate 10.0.12.1 via E0/0</span>
              <span class="text-xs font-medium" :class="task1Done?'text-success':'text-grey'">{{ task1Progress }}/6</span>
            </div>
            <div class="px-3 py-2">
              <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">R2</span>
              <div class="space-y-1 ml-1">
                <div v-for="item in task1Items" :key="'t1-'+item.key" class="flex items-center gap-2">
                  <div class="flex-shrink-0 rounded-full" :style="dot(r2Completion[item.key])"></div>
                  <code class="text-base" :class="r2Completion[item.key]?'text-success':''">{{ item.label }}</code>
                </div>
              </div>
              <p class="text-xs mt-2 ml-1" style="color:#6b7280">Verify: ping 209.165.200.224 from Sw1 · show ip nat translations on R2</p>
            </div>
          </div>

          <!-- Task 2 -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{border:'1px solid '+(task2Done?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:task2Done?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{width:'20px',height:'20px',fontSize:'10px',background:task2Done?'#28C76F':'#4a5568'}">2</span>
              <span class="font-semibold text-sm flex-1">NTP client on Sw1 → R2 loopback</span>
              <span class="text-xs font-medium" :class="task2Done?'text-success':'text-grey'">{{ task2Done?1:0 }}/1</span>
            </div>
            <div class="px-3 py-2">
              <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">Sw1</span>
              <div class="space-y-1 ml-1">
                <div v-for="item in task2Items" :key="'t2-'+item.key" class="flex items-center gap-2">
                  <div class="flex-shrink-0 rounded-full" :style="dot(sw1Completion[item.key])"></div>
                  <code class="text-base" :class="sw1Completion[item.key]?'text-success':''">{{ item.label }}</code>
                </div>
              </div>
              <p class="text-xs mt-2 ml-1" style="color:#6b7280">Verify: show ntp status on Sw1</p>
            </div>
          </div>

          <!-- Task 3 -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{border:'1px solid '+(task3Done?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:task3Done?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{width:'20px',height:'20px',fontSize:'10px',background:task3Done?'#28C76F':'#4a5568'}">3</span>
              <span class="font-semibold text-sm flex-1">DHCP relay on Sw1 VLAN 101 + bring up R3 E0/0</span>
              <span class="text-xs font-medium" :class="task3Done?'text-success':'text-grey'">{{ task3Progress }}/4</span>
            </div>
            <div class="px-3 py-2">
              <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">Sw1</span>
              <div class="space-y-1 ml-1 mb-2">
                <div v-for="item in task3Sw1Items" :key="'t3sw1-'+item.key" class="flex items-center gap-2">
                  <div class="flex-shrink-0 rounded-full" :style="dot(sw1Completion[item.key])"></div>
                  <code class="text-base" :class="sw1Completion[item.key]?'text-success':''">{{ item.label }}</code>
                </div>
              </div>
              <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">R3</span>
              <div class="space-y-1 ml-1">
                <div v-for="item in task3R3Items" :key="'t3r3-'+item.key" class="flex items-center gap-2">
                  <div class="flex-shrink-0 rounded-full" :style="dot(r3Completion[item.key])"></div>
                  <code class="text-base" :class="r3Completion[item.key]?'text-success':''">{{ item.label }}</code>
                </div>
              </div>
              <p class="text-xs mt-2 ml-1" style="color:#6b7280">Verify: show ip int brief on R3</p>
            </div>
          </div>

          <!-- Task 4 -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{border:'1px solid '+(task4Done?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:task4Done?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{width:'20px',height:'20px',fontSize:'10px',background:task4Done?'#28C76F':'#4a5568'}">4</span>
              <span class="font-semibold text-sm flex-1">SSH server on Sw1 — RSA 2048, SSHv2, VTY 0-4</span>
              <span class="text-xs font-medium" :class="task4Done?'text-success':'text-grey'">{{ task4Progress }}/9</span>
            </div>
            <div class="px-3 py-2">
              <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">Sw1</span>
              <div class="space-y-1 ml-1">
                <div v-for="item in task4Items" :key="'t4-'+item.key" class="flex items-center gap-2">
                  <div class="flex-shrink-0 rounded-full" :style="dot(sw1Completion[item.key])"></div>
                  <code class="text-base" :class="sw1Completion[item.key]?'text-success':''">{{ item.label }}</code>
                </div>
              </div>
              <p class="text-xs mt-2 ml-1" style="color:#6b7280">Verify: ssh -l admin 10.0.12.1 from R2</p>
            </div>
          </div>

          <!-- Save -->
          <div class="rounded-lg mb-2 overflow-hidden" :style="{border:'1px solid '+(saveDone?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:saveDone?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <feather-icon :icon="saveDone?'CheckCircleIcon':'CircleIcon'" :svgClasses="saveDone?'text-success':'text-grey'" size="16" class="flex-shrink-0" />
              <span class="font-semibold text-sm flex-1">Save Configuration</span>
              <span class="text-xs font-medium" :class="saveDone?'text-success':'text-grey'">{{ saveProgress }}/3</span>
            </div>
            <div class="px-3 py-2">
              <div v-for="dk in ['r2','r3','sw1']" :key="'s-'+dk" class="mb-2">
                <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">{{ devLabel(dk) }}</span>
                <div class="space-y-1 ml-1">
                  <div class="flex items-center gap-2">
                    <div class="flex-shrink-0 rounded-full" :style="dot(getComp(dk).saved)"></div>
                    <code class="text-base" :class="getComp(dk).saved?'text-success':''">copy running-config startup-config</code>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </vx-card>
      </div>

      <div class="vx-col lg:w-8/12 md:w-7/12 sm:w-5/5">
        <div style="height: 35rem">
          <vue-command v-show="sel==='r2'"  key="r2"  id="r2_terminal"  :commands="r2Commands"  :prompt="r2Prompt"  :show-intro="true" intro="Cisco IOS Software — Type 'help' for available commands." style="background-color:#111111;border:1px solid #181d2a;border-radius:0.5rem;height:100%" title="R2" />
          <vue-command v-show="sel==='r3'"  key="r3"  id="r3_terminal"  :commands="r3Commands"  :prompt="r3Prompt"  :show-intro="true" intro="Cisco IOS Software — Type 'help' for available commands." style="background-color:#111111;border:1px solid #181d2a;border-radius:0.5rem;height:100%" title="R3" />
          <vue-command v-show="sel==='sw1'" key="sw1" id="sw1_terminal" :commands="sw1Commands" :prompt="sw1Prompt" :show-intro="true" intro="Cisco IOS Software — Type 'help' for available commands." style="background-color:#111111;border:1px solid #181d2a;border-radius:0.5rem;height:100%" title="Sw1" />
        </div>

        <!-- Topology -->
        <div class="topology-card">
          <img :src="topologyImage" alt="Network topology" class="topology-img" />
        </div>
      </div>

    </div>
  </div>
</template>

<script>
/* eslint-disable */
import VueCommand, { createStdout, createStderr } from 'vue-command';
import 'vue-command/dist/vue-command.css';

const HELP = 'Type commands as shown in the checklist. Use show/ping/ssh to verify.';

const mkCommands = (dev, vm) => ({
  help:            () => createStdout(HELP),
  enable:          () => vm.iosEnable(dev),
  configure:       (x) => vm.iosConfigure(dev, x),
  conf:            (x) => vm.iosConfigure(dev, x),
  interface:       (x) => vm.iosInterface(dev, x),
  int:             (x) => vm.iosInterface(dev, x),
  ip:              (x) => vm.iosIp(dev, x),
  'access-list':   (x) => vm.iosAccessList(dev, x),
  ntp:             (x) => vm.iosNtp(dev, x),
  hostname:        (x) => vm.iosHostname(dev, x),
  crypto:          (x) => vm.iosCrypto(dev, x),
  username:        (x) => vm.iosUsername(dev, x),
  line:            (x) => vm.iosLine(dev, x),
  login:           (x) => vm.iosLogin(dev, x),
  transport:       (x) => vm.iosTransport(dev, x),
  'exec-timeout':  (x) => vm.iosExecTimeout(dev, x),
  no:              (x) => vm.iosNo(dev, x),
  ping:            (x) => vm.iosPing(dev, x),
  ssh:             (x) => vm.iosSsh(dev, x),
  show:            (x) => vm.iosShow(dev, x),
  exit:            () => vm.iosExit(dev),
  end:             () => vm.iosEnd(dev),
  copy:            (x) => vm.iosCopy(dev, x),
});

export default {
  data() {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),
      topologyImage: 'https://ip-learn.b-cdn.net/simulations/ccna-topologies/PAT_NTP_DHCP_Relay_Simulation.png',
      sel: 'r2',
      totalScore: 0,

      r2:  { mode: 'exec', currentIf: null },
      r3:  { mode: 'exec', currentIf: null },
      sw1: { mode: 'exec', currentIf: null },

      // r2(7) + r3(3) + sw1(13) = 23 total
      r2Completion: {
        e00If: false, natOutside: false,
        e01If: false, natInside: false,
        accessList: false, natOverload: false,
        saved: false,
      },
      r3Completion: { e00If: false, noShut: false, saved: false },
      sw1Completion: {
        ntpServer: false,
        vlan101If: false, helperAddr: false,
        hostname: false, domainName: false, cryptoKey: false,
        sshV2: false, username: false,
        lineVty: false, loginLocal: false, transportSSH: false, execTimeout: false,
        saved: false,
      },

      r2Commands: null, r3Commands: null, sw1Commands: null,

      task1Items: [
        { key: 'e00If',       label: 'interface e0/0' },
        { key: 'natOutside',  label: 'ip nat outside' },
        { key: 'e01If',       label: 'interface e0/1' },
        { key: 'natInside',   label: 'ip nat inside' },
        { key: 'accessList',  label: 'access-list 1 permit 10.0.12.1 0.0.0.0' },
        { key: 'natOverload', label: 'ip nat inside source list 1 interface e0/0 overload' },
      ],
      task2Items: [
        { key: 'ntpServer', label: 'ntp server 10.2.2.2' },
      ],
      task3Sw1Items: [
        { key: 'vlan101If',  label: 'interface vlan 101' },
        { key: 'helperAddr', label: 'ip helper-address 10.0.12.2' },
      ],
      task3R3Items: [
        { key: 'e00If',  label: 'interface e0/0' },
        { key: 'noShut', label: 'no shut' },
      ],
      task4Items: [
        { key: 'hostname',     label: 'hostname Sw1' },
        { key: 'domainName',   label: 'ip domain-name abcxyz.com' },
        { key: 'cryptoKey',    label: 'crypto key generate rsa modulus 2048' },
        { key: 'sshV2',        label: 'ip ssh version 2' },
        { key: 'username',     label: 'username admin privilege 15 secret StrongPass!' },
        { key: 'lineVty',      label: 'line vty 0 4' },
        { key: 'loginLocal',   label: 'login local' },
        { key: 'transportSSH', label: 'transport input ssh' },
        { key: 'execTimeout',  label: 'exec-timeout 5 0' },
      ],
    };
  },

  computed: {
    r2Prompt()  { const m=this.r2.mode;  return m==='config-if'?'R2(config-if)#':m==='config'?'R2(config)#':'R2#'; },
    r3Prompt()  { const m=this.r3.mode;  return m==='config-if'?'R3(config-if)#':m==='config'?'R3(config)#':'R3#'; },
    sw1Prompt() {
      const m = this.sw1.mode;
      if (m === 'config-if')   return 'Sw1(config-if)#';
      if (m === 'config-line') return 'Sw1(config-line)#';
      if (m === 'config')      return 'Sw1(config)#';
      return 'Sw1#';
    },

    task1Progress() {
      const c = this.r2Completion;
      return [c.e00If, c.natOutside, c.e01If, c.natInside, c.accessList, c.natOverload].filter(Boolean).length;
    },
    task1Done() { return this.task1Progress === 6; },

    task2Done() { return !!this.sw1Completion.ntpServer; },

    task3Progress() {
      const cs = this.sw1Completion, cr = this.r3Completion;
      return [cs.vlan101If, cs.helperAddr, cr.e00If, cr.noShut].filter(Boolean).length;
    },
    task3Done() { return this.task3Progress === 4; },

    task4Progress() {
      const c = this.sw1Completion;
      return [c.hostname, c.domainName, c.cryptoKey, c.sshV2, c.username,
              c.lineVty, c.loginLocal, c.transportSSH, c.execTimeout].filter(Boolean).length;
    },
    task4Done() { return this.task4Progress === 9; },

    saveProgress() {
      return [this.r2Completion.saved, this.r3Completion.saved, this.sw1Completion.saved].filter(Boolean).length;
    },
    saveDone() { return this.saveProgress === 3; },
  },

  mounted() {
    this.dataLocal.options.showMarkButton = false;
    this.$emit('simulation_update_options', this.dataLocal);
    this.r2Commands  = mkCommands('r2', this);
    this.r3Commands  = mkCommands('r3', this);
    this.sw1Commands = mkCommands('sw1', this);
  },

  methods: {
    getComp(k) { return this[k + 'Completion']; },
    devLabel(k) { return { r2:'R2', r3:'R3', sw1:'Sw1' }[k] || k; },

    dot(val) {
      return { width:'8px', height:'8px', background: val?'#28C76F':'transparent', border:'2px solid '+(val?'#28C76F':'#6b7280') };
    },
    guide(msg) {
      return `<span style="color:#28C76F;display:block;margin-top:6px;padding:4px 8px;border-left:2px solid #28C76F;font-size:0.85em;line-height:1.5">${msg}</span>`;
    },
    normalizeIf(ifStr) {
      return (ifStr||'').toLowerCase()
        .replace(/^gigabitethernet/,'').replace(/^fastethernet/,'').replace(/^ethernet/,'')
        .replace(/^gi(?=\d)/,'').replace(/^fa(?=\d)/,'').replace(/^e(?=\d)/,'').replace(/^g(?=\d)/,'')
        .trim();
    },
    updateScore() {
      let score = 0;
      [this.r2Completion, this.r3Completion, this.sw1Completion].forEach(c => Object.values(c).forEach(v => { if (v) score++; }));
      this.totalScore = score;
      this.$forceUpdate();
      this.$emit('simulation_update_score', score);
      if (score >= 23) setTimeout(() => this.$emit('simulation_full_correct', score), 500);
    },

    iosEnable(dev) { this[dev].mode = 'exec'; return createStdout(''); },

    iosConfigure(dev, x) {
      if (this[dev].mode !== 'exec') return createStderr('% Already in configuration mode — type "end" first');
      if (x._[1] === 'terminal' || x._[1] === 't') { this[dev].mode = 'config'; return createStdout('Enter configuration commands, one per line.  End with CNTL/Z.'); }
      return createStderr('% Invalid input detected');
    },

    iosExit(dev) {
      const s = this[dev];
      if (s.mode === 'config-if' || s.mode === 'config-line') { s.mode = 'config'; s.currentIf = null; }
      else if (s.mode === 'config') { s.mode = 'exec'; }
      return createStdout('');
    },
    iosEnd(dev) { this[dev].mode = 'exec'; this[dev].currentIf = null; return createStdout(''); },

    iosInterface(dev, x) {
      const s = this[dev];
      const validModes = ['config', 'config-if'];
      if (!validModes.includes(s.mode)) return createStderr('% Must be in configuration mode');
      let ifArg = String(x._[1] || '');
      if (ifArg.toLowerCase() === 'vlan' && x._[2]) ifArg = 'vlan' + x._[2];
      const ifNorm = this.normalizeIf(ifArg) || ifArg.toLowerCase();
      s.mode = 'config-if'; s.currentIf = ifNorm;
      const c = this[dev + 'Completion'];
      if (dev === 'r2') {
        if (ifNorm === '0/0' && !c.e00If) { c.e00If = true; this.updateScore(); }
        if (ifNorm === '0/1' && !c.e01If) { c.e01If = true; this.updateScore(); }
      }
      if (dev === 'r3' && ifNorm === '0/0' && !c.e00If) { c.e00If = true; this.updateScore(); }
      if (dev === 'sw1' && ifNorm === 'vlan101' && !c.vlan101If) { c.vlan101If = true; this.updateScore(); }
      return createStdout('');
    },

    iosIp(dev, x) {
      const s = this[dev];
      const sub1 = (x._[1]||'').toLowerCase();
      const sub2 = (x._[2]||'').toLowerCase();
      const sub3 = (x._[3]||'').toLowerCase();
      const c = this[dev + 'Completion'];

      if (s.mode === 'config-if') {
        if (sub1 === 'nat' && sub2 === 'outside') {
          if (dev === 'r2' && s.currentIf === '0/0' && !c.natOutside) {
            c.natOutside = true; this.updateScore();
            return createStdout(this.guide('E0/0 marked as NAT outside (ISP-facing). Packets leaving this interface will have source IPs translated. → "interface e0/1" then "ip nat inside".'));
          }
          return createStdout('');
        }
        if (sub1 === 'nat' && sub2 === 'inside' && sub3 !== 'source') {
          if (dev === 'r2' && s.currentIf === '0/1' && !c.natInside) {
            c.natInside = true; this.updateScore();
            return createStdout(this.guide('E0/1 marked as NAT inside (LAN-facing). Traffic from 10.0.12.1 entering here will be NATed at E0/0. → "exit" then configure ACL and NAT overload.'));
          }
          return createStdout('');
        }
        if (sub1 === 'helper-address') {
          const addr = String(x._[2]||'');
          if (dev === 'sw1' && addr === '10.0.12.2' && !c.helperAddr) {
            c.helperAddr = true; this.updateScore();
            return createStdout(this.guide('DHCP relay configured — Sw1 forwards DHCP broadcasts on VLAN 101 to the DHCP server at 10.0.12.2 (R2). → On R3: "interface e0/0" then "no shut".'));
          }
          return createStdout('');
        }
        return createStderr('% Invalid input detected');
      }

      if (s.mode === 'config') {
        if (sub1 === 'nat' && sub2 === 'inside' && sub3 === 'source') {
          const list = String(x._[5]||''), ifArg = String(x._[7]||''), ovl = (x._[8]||'').toLowerCase();
          if (dev === 'r2' && list === '1' && this.normalizeIf(ifArg) === '0/0' && ovl === 'overload' && !c.natOverload) {
            c.natOverload = true; this.updateScore();
            return createStdout(this.guide('PAT configured — 10.0.12.1 maps to R2 E0/0\'s IP (209.165.210.2) with port multiplexing. → Verify from Sw1: "end" then "ping 209.165.200.224". Use "show ip nat translations" on R2.'));
          }
          return createStdout('');
        }
        if (sub1 === 'domain-name') {
          const domain = (x._[2]||'').toLowerCase();
          if (dev === 'sw1' && domain === 'abcxyz.com' && !c.domainName) {
            c.domainName = true; this.updateScore();
            return createStdout(this.guide('Domain "abcxyz.com" set — FQDN will be Sw1.abcxyz.com, embedded in the RSA certificate. → "crypto key generate rsa modulus 2048".'));
          }
          return createStdout('');
        }
        if (sub1 === 'ssh' && sub2 === 'version' && String(x._[3]||'') === '2') {
          if (dev === 'sw1' && !c.sshV2) {
            c.sshV2 = true; this.updateScore();
            return createStdout(this.guide('SSHv2 enabled — stronger encryption, resistant to man-in-the-middle attacks. → "username admin privilege 15 secret StrongPass!".'));
          }
          return createStdout('');
        }
        return createStderr('% Invalid input detected');
      }
      return createStderr('% Invalid input detected');
    },

    iosAccessList(dev, x) {
      const s = this[dev];
      if (s.mode !== 'config') return createStderr('% Must be in global configuration mode');
      const listNum = String(x._[1]||''), action = (x._[2]||'').toLowerCase(), network = String(x._[3]||''), wildcard = String(x._[4]||'');
      const c = this[dev + 'Completion'];
      if (dev === 'r2' && listNum === '1' && action === 'permit' && network === '10.0.12.1' && wildcard === '0.0.0.0' && !c.accessList) {
        c.accessList = true; this.updateScore();
        return createStdout(this.guide('ACL 1 created matching 10.0.12.1/32 (wildcard 0.0.0.0 = exact host). PAT will apply to traffic from this address. → "ip nat inside source list 1 interface e0/0 overload".'));
      }
      return createStdout('');
    },

    iosNtp(dev, x) {
      const s = this[dev];
      if (s.mode !== 'config') return createStderr('% Must be in global configuration mode');
      const c = this[dev + 'Completion'];
      if (dev === 'sw1' && (x._[1]||'').toLowerCase() === 'server' && String(x._[2]||'') === '10.2.2.2' && !c.ntpServer) {
        c.ntpServer = true; this.updateScore();
        return createStdout(this.guide('NTP server set to 10.2.2.2 (R2\'s loopback). Sw1 will synchronize its clock to R2. Wait ~1 minute then verify with "show ntp status" — look for "Clock is synchronized".'));
      }
      return createStdout('');
    },

    iosHostname(dev, x) {
      const s = this[dev];
      if (s.mode !== 'config') return createStderr('% Must be in global configuration mode');
      const c = this[dev + 'Completion'];
      if (dev === 'sw1' && (x._[1]||'').toLowerCase() === 'sw1' && !c.hostname) {
        c.hostname = true; this.updateScore();
        return createStdout(this.guide('Hostname set to "Sw1". Required before generating RSA keys — the hostname is part of the key\'s FQDN. → "ip domain-name abcxyz.com".'));
      }
      return createStdout('');
    },

    iosCrypto(dev, x) {
      const s = this[dev];
      if (s.mode !== 'config') return createStderr('% Must be in global configuration mode');
      const sub1=(x._[1]||'').toLowerCase(), sub2=(x._[2]||'').toLowerCase(), sub3=(x._[3]||'').toLowerCase();
      if (sub1 !== 'key' || sub2 !== 'generate' || sub3 !== 'rsa') return createStderr('% Invalid input detected');
      const c = this[dev + 'Completion'];
      if (dev === 'sw1') {
        if (!c.hostname || !c.domainName) return createStderr('% Please configure hostname and ip domain-name first');
        const sub4 = (x._[4]||'').toLowerCase();
        const bits = sub4 === 'general-keys' ? String(x._[6]||'') : String(x._[5]||'');
        if (bits === '2048' && !c.cryptoKey) {
          c.cryptoKey = true; this.updateScore();
          return createStdout(
            'The name for the keys will be: Sw1.abcxyz.com<br>% Generating 2048 bit RSA keys...<br>[OK]' +
            this.guide('2048-bit RSA key pair generated. SSH can now use this key for encryption. → "ip ssh version 2".')
          );
        }
      }
      return createStdout('');
    },

    iosUsername(dev, x) {
      const s = this[dev];
      if (s.mode !== 'config') return createStderr('% Must be in global configuration mode');
      const c = this[dev + 'Completion'];
      if (dev === 'sw1' && (x._[1]||'').toLowerCase() === 'admin' && String(x._[3]||'') === '15' && !c.username) {
        c.username = true; this.updateScore();
        return createStdout(this.guide('User "admin" with privilege 15 created locally. SSH clients will authenticate using this account. → "line vty 0 4".'));
      }
      return createStdout('');
    },

    iosLine(dev, x) {
      const s = this[dev];
      if (s.mode !== 'config') return createStderr('% Must be in global configuration mode');
      const c = this[dev + 'Completion'];
      if (dev === 'sw1' && (x._[1]||'').toLowerCase() === 'vty') {
        s.mode = 'config-line';
        if (!c.lineVty) { c.lineVty = true; this.updateScore(); }
        return createStdout(this.guide('VTY 0-4 line configuration entered. → "login local", "transport input ssh", "exec-timeout 5 0".'));
      }
      return createStdout('');
    },

    iosLogin(dev, x) {
      const s = this[dev];
      if (s.mode !== 'config-line') return createStderr('% Must be in line configuration mode — type "line vty 0 4" first');
      const c = this[dev + 'Completion'];
      if (dev === 'sw1' && (x._[1]||'').toLowerCase() === 'local' && !c.loginLocal) {
        c.loginLocal = true; this.updateScore();
        return createStdout(this.guide('VTY lines use local user database for authentication. → "transport input ssh".'));
      }
      return createStdout('');
    },

    iosTransport(dev, x) {
      const s = this[dev];
      if (s.mode !== 'config-line') return createStderr('% Must be in line configuration mode');
      const c = this[dev + 'Completion'];
      if (dev === 'sw1' && (x._[1]||'').toLowerCase() === 'input' && (x._[2]||'').toLowerCase() === 'ssh' && !c.transportSSH) {
        c.transportSSH = true; this.updateScore();
        return createStdout(this.guide('VTY lines restricted to SSH only — Telnet is blocked. → "exec-timeout 5 0".'));
      }
      return createStdout('');
    },

    iosExecTimeout(dev, x) {
      const s = this[dev];
      if (s.mode !== 'config-line') return createStderr('% Must be in line configuration mode');
      const c = this[dev + 'Completion'];
      if (dev === 'sw1' && String(x._[1]||'') === '5' && String(x._[2]||'') === '0' && !c.execTimeout) {
        c.execTimeout = true; this.updateScore();
        return createStdout(this.guide('Exec timeout set to 5 min 0 sec (300 seconds). Idle SSH sessions will be disconnected after inactivity. → Verify SSH: on R2 run "ssh -l admin 10.0.12.1".'));
      }
      return createStdout('');
    },

    iosNo(dev, x) {
      const s = this[dev];
      if (s.mode !== 'config-if') return createStderr('% Must be in interface configuration mode');
      const sub1 = (x._[1]||'').toLowerCase();
      const c = this[dev + 'Completion'];
      if ((sub1 === 'shut' || sub1 === 'shutdown') && dev === 'r3' && s.currentIf === '0/0' && !c.noShut) {
        c.noShut = true; this.updateScore();
        return createStdout(
          '%LINEPROTO-5-UPDOWN: Line protocol on Interface GigabitEthernet0/0, changed state to up<br>' +
          '%DHCP-6-ADDRESS_ASSIGN: Interface Ethernet0/0 assigned DHCP address 10.101.20.3, mask 255.255.255.0, hostname R3' +
          this.guide('R3 E0/0 is up and received 10.101.20.3 via DHCP (relayed through Sw1 to R2). → Verify with "show ip int brief" on R3.')
        );
      }
      return createStdout('');
    },

    iosPing(dev, x) {
      const s = this[dev];
      if (s.mode !== 'exec') return createStderr('% Must be in exec mode — type "end" first');
      const target = (x._[1]||'').toLowerCase();
      if (dev === 'sw1' && target === '209.165.200.224') {
        if (this.r2Completion.natOverload) {
          return createStdout(
            'Type escape sequence to abort.<br>Sending 5, 100-byte ICMP Echos to 209.165.200.224, timeout is 2 seconds:<br>..!!!</b><br>Success rate is 60 percent (3/5), round-trip min/avg/max = 0/0/0 ms' +
            this.guide('PAT verified! 10.0.12.1 translates to 209.165.210.2 (R2 E0/0). First 2 packets timeout during ARP resolution. → Use "show ip nat translations" on R2 to see the entries.')
          );
        }
        return createStdout('.....<br>Success rate is 0 percent (0/5)' + this.guide('Ping failed — configure PAT on R2 first (Task 1).'));
      }
      return createStdout('.....<br>Success rate is 0 percent (0/5)');
    },

    iosSsh(dev, x) {
      const s = this[dev];
      if (s.mode !== 'exec') return createStderr('% Must be in exec mode — type "end" first');
      const param = (x._[1]||'').toLowerCase(), user = String(x._[2]||''), target = String(x._[3]||'');
      if (dev === 'r2' && param === '-l' && user.toLowerCase() === 'admin' && target === '10.0.12.1') {
        const c = this.sw1Completion;
        if (c.cryptoKey && c.sshV2 && c.username && c.loginLocal && c.transportSSH) {
          return createStdout('Password: <br>Sw1#' + this.guide('SSH to Sw1 successful! All SSH components are properly configured.'));
        }
        return createStdout('ssh: connect to host 10.0.12.1 port 22: Connection refused' + this.guide('SSH not ready — complete Task 4 on Sw1 first.'));
      }
      return createStdout('% Connection failed');
    },

    iosShow(dev, x) {
      const sub1=(x._[1]||'').toLowerCase(), sub2=(x._[2]||'').toLowerCase(), sub3=(x._[3]||'').toLowerCase();

      if (dev === 'r2' && sub1 === 'ip' && sub2 === 'nat' && sub3 === 'translations') {
        if (this.r2Completion.natOverload) {
          return createStdout(
            'Pro&nbsp;&nbsp;Inside global&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Inside local&nbsp;&nbsp;Outside local&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Outside global<br>' +
            'icmp&nbsp;209.165.210.2:2&nbsp;10.0.12.1:2&nbsp;&nbsp;&nbsp;209.165.200.224:2&nbsp;209.165.200.224:2<br>' +
            'icmp&nbsp;209.165.210.2:3&nbsp;10.0.12.1:3&nbsp;&nbsp;&nbsp;209.165.200.224:3&nbsp;209.165.200.224:3' +
            this.guide('PAT confirmed: 10.0.12.1 (inside local) → 209.165.210.2 (inside global, R2 E0/0 IP).')
          );
        }
        return createStdout('(empty — configure PAT first)');
      }

      if (dev === 'sw1' && sub1 === 'ntp' && sub2 === 'status') {
        if (this.sw1Completion.ntpServer) {
          return createStdout(
            'Clock is synchronized, stratum 16, reference is 10.0.12.2<br>' +
            'clock offset is 0.00 msec, root delay is 0.00 msec' +
            this.guide('Sw1 is synchronized with R2\'s NTP server at 10.0.12.2.')
          );
        }
        return createStdout('Clock is unsynchronized' + this.guide('"ntp server 10.2.2.2" not configured yet.'));
      }

      if (dev === 'r3' && sub1 === 'ip' && (sub2 === 'int' || sub2 === 'interface') && sub3 === 'brief') {
        if (this.r3Completion.noShut) {
          return createStdout(
            'Interface&nbsp;&nbsp;&nbsp;&nbsp;IP-Address&nbsp;&nbsp;&nbsp;&nbsp;OK?&nbsp;Method&nbsp;Status&nbsp;&nbsp;&nbsp;&nbsp;Protocol<br>' +
            'Ethernet0/0&nbsp;&nbsp;10.101.20.3&nbsp;&nbsp;&nbsp;YES&nbsp;DHCP&nbsp;&nbsp;&nbsp;up&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;up<br>' +
            'Ethernet0/1&nbsp;&nbsp;unassigned&nbsp;&nbsp;&nbsp;&nbsp;YES&nbsp;unset&nbsp;&nbsp;admin down&nbsp;&nbsp;&nbsp;&nbsp;down' +
            this.guide('R3 E0/0 received 10.101.20.3 via DHCP relay through Sw1.')
          );
        }
        return createStdout(
          'Interface&nbsp;&nbsp;&nbsp;&nbsp;IP-Address&nbsp;&nbsp;&nbsp;&nbsp;OK?&nbsp;Method&nbsp;Status&nbsp;&nbsp;&nbsp;&nbsp;Protocol<br>' +
          'Ethernet0/0&nbsp;&nbsp;unassigned&nbsp;&nbsp;&nbsp;&nbsp;YES&nbsp;unset&nbsp;&nbsp;admin down&nbsp;&nbsp;&nbsp;&nbsp;down' +
          this.guide('R3 E0/0 still down — type "interface e0/0" then "no shut".')
        );
      }

      return createStderr('% Invalid input detected');
    },

    iosCopy(dev, x) {
      if (this[dev].mode !== 'exec') return createStderr('% Must be in exec mode — type "end" first');
      const c = this[dev + 'Completion'];
      if (x._[1] === 'running-config' && x._[2] === 'startup-config') {
        if (!c.saved) { c.saved = true; this.updateScore(); }
        return createStdout('Destination filename [startup-config]?<br>Building configuration...<br>[OK]' +
          this.guide(`${this.devLabel(dev)} saved. ` + (this.saveDone ? '✓ All devices saved — simulation complete!' : '→ Save remaining devices.')));
      }
      return createStderr('% Invalid input detected');
    },
  },

  components: { VueCommand },
  props: { data: { type: Object, required: true } },
};
</script>

<style>
#r2_terminal, #r3_terminal, #sw1_terminal { overflow: hidden !important; }

.topology-card {
  margin-top: 1.5rem;
  background-color: #111111;
  border: 1px solid #181d2a;
  border-radius: 0.5rem;
  overflow: hidden;
  line-height: 0;
}
.topology-img {
  display: block;
  width: 100%;
  height: auto;
  max-width: 100%;
}
</style>

